// Local translations
export const T = {
  en_GB: {
    deleteNote: "Delete Note",
    deleteConfirmation: (title: string) =>
      `Are you sure you want to delete "${title}"? This action cannot be undone.`,
    delete: "Delete",
    cancel: "Cancel",
    titleRequired: "Title is required",
    failedToUpdate: "Failed to update note",
    failedToCreate: "Failed to create note",
    title: "Title",
    content: "Content",
    enterNoteTitle: "Enter note title",
    writeNoteHere: "Write your note here...",
    saving: "Saving...",
    saved: "Saved",
    save: "Save",
    newNote: "New note",
    backToNotes: "Back",
  },
  nb_NO: {
    deleteNote: "Slett notat",
    deleteConfirmation: (title: string) =>
      `Er du sikker på at du vil slette "${title}"? Denne handlingen kan ikke angres.`,
    delete: "Slett",
    cancel: "Avbryt",
    titleRequired: "Tittel er påkrevd",
    failedToUpdate: "Kunne ikke oppdatere notatet",
    failedToCreate: "Kunne ikke opprette notatet",
    title: "Tittel",
    content: "Innhold",
    enterNoteTitle: "Skriv inn notattittel",
    writeNoteHere: "Skriv notatet ditt her...",
    saving: "Lagrer...",
    saved: "Lagret",
    save: "Lagre",
    newNote: "Nytt notat",
    backToNotes: "Tilbake",
  },
} as const;
